import { render, staticRenderFns } from "./memberwxdialog.vue?vue&type=template&id=73265adc&scoped=true"
import script from "./memberwxdialog.vue?vue&type=script&lang=js"
export * from "./memberwxdialog.vue?vue&type=script&lang=js"
import style0 from "./memberwxdialog.vue?vue&type=style&index=0&id=73265adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73265adc",
  null
  
)

export default component.exports